import { Colors } from '@shared/config/colors/types';
import { FeedbackRequestStatus } from '@shared/model/feedback-request';

export const FEEDBACK_REQUEST_BACKGROUND_COLOR_STATUS_MAP: Record<FeedbackRequestStatus, Colors> = {
    created: 'cyan_10',
    progress: 'attention_10',
    canceled: 'attention_10',
    completed: 'success_10',
};

export const FEEDBACK_REQUEST_TEXT_COLOR_STATUS_MAP: Record<FeedbackRequestStatus, Colors> = {
    created: 'cyan_50',
    progress: 'warning_50',
    canceled: 'warning_50',
    completed: 'success_50',
};

export const FEEDBACK_REQUEST_TEXT_STATUS_MAP: Record<FeedbackRequestStatus, string> = {
    created: 'Создано',
    progress: 'В работе',
    canceled: 'Отменено',
    completed: 'Закрыто',
};

export const FEEDBACK_REQUEST_NEXT_STEP_STATUS_MAP: Record<FeedbackRequestStatus, FeedbackRequestStatus | null> = {
    created: 'progress',
    progress: 'completed',
    canceled: null,
    completed: 'progress',
};

export const FEEDBACK_REQUEST_SUCCESS_MESSAGE_STATUS_MAP: Record<Exclude<FeedbackRequestStatus, 'canceled'>, string> = {
    created: 'Обращение возвращено к работе',
    progress: 'Обращение взято в работу',
    completed: 'Обращение закрыто',
};

export const FEEDBACK_REQUEST_ERROR_MESSAGE_STATUS_MAP: Record<Exclude<FeedbackRequestStatus, 'canceled'>, string> = {
    created: 'Не удалось вернуть обращение в работу',
    progress: 'Не удалось взять обращение в рбаоту',
    completed: 'Не удалось закрыть обращение',
};
